export function clickOutside(el: HTMLElement | null, onClickOutside: () => void) {
  const onClick = (e: MouseEvent) => {
    if (el && !el.contains(e.target as Node)) {
      onClickOutside();
    }
  };

  document.body.addEventListener('click', onClick);

  return () => document.body.removeEventListener('click', onClick);
}
